import React from 'react'

export default (props) => {
	const {
		blockClassName,
	} = props

	let symbolClassName = 'symbol-hamburger'

	if (blockClassName) {
		symbolClassName = `${blockClassName}__svg`
	}

	return (
		<svg className={symbolClassName} viewBox="0 0 40 33.16" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="6" />
			<rect y="27.16" width="40" height="6" />
			<rect y="13.58" width="40" height="6" />
		</svg>
	)
}



// WEBPACK FOOTER //
// ./src/common/assets/hamburger.js